'use client';

import { forwardRef } from 'react';
import { DEFAULT_AI_AGENT_NAME } from '@ametista-ai/api-schema/ai-agent';
import { NodeViewComponentProps } from '@handlewithcare/react-prosemirror';
import { useCurrentAgency } from '@/queries/agencies/useCurrentAgency';
import { useUser } from '@/queries/users/useUser';

function AiMention() {
  const { data: agency } = useCurrentAgency();
  return <span>{agency?.aiAgentName ?? DEFAULT_AI_AGENT_NAME}</span>;
}

function UserMentionInternal({ userId }: { userId: string }) {
  const { data: user } = useUser(userId);
  return <span>{user?.displayName ?? 'Loading...'}</span>;
}

export const UserMention = forwardRef<HTMLDivElement, NodeViewComponentProps>(function UserMention(
  { nodeProps, ...props },
  ref
) {
  if (nodeProps.node.attrs.modelId === 'ai') {
    return (
      <span className="mention ai" ref={ref} {...props}>
        <AiMention />
      </span>
    );
  }

  return (
    <span className="mention" ref={ref} {...props}>
      <UserMentionInternal userId={nodeProps.node.attrs.modelId} />
    </span>
  );
});
